// Shared chrome (header + footer) for all public marketing pages. Kept
// framework-free like the rest of the app — plain template strings plus a
// small attach step for interactive bits (mobile nav toggle, active link).
import { brandMarkHtml } from '../../components/brandMark.js';
import { PAYMENTS_ENABLED } from '../../lib/featureFlags.js';

export const SUPPORT_EMAIL = 'support@simustage.com';

export function mktHeader(active, signedIn) {
  const link = (path, label) =>
    `<a href="#${path}" class="mkt-nav-link${active === path ? ' is-active' : ''}">${label}</a>`;
  return `
    <header class="mkt-header">
      <div class="mkt-header-inner">
        <a href="#/" class="mkt-brand">${brandMarkHtml()} Simustage</a>
        <nav class="mkt-nav" id="mkt-nav">
          ${link('/', 'Home')}
          ${PAYMENTS_ENABLED ? link('/pricing', 'Pricing') : ''}
          ${link('/schools', 'For schools')}
          ${link('/about', 'About')}
          ${link('/contact', 'Contact')}
        </nav>
        <div class="mkt-header-actions">
          ${signedIn
            ? `<a href="#/" class="btn btn-primary">Go to dashboard</a>`
            : `<a href="#/login" class="btn btn-primary">Log in</a>`}
        </div>
        <button type="button" class="mkt-nav-toggle" id="mkt-nav-toggle" aria-label="Toggle menu">☰</button>
      </div>
    </header>
  `;
}

export function mktFooter() {
  const year = new Date().getFullYear();
  return `
    <footer class="mkt-footer">
      <div class="mkt-footer-inner">
        <div class="mkt-footer-brand">
          <div class="mkt-brand">${brandMarkHtml()} Simustage</div>
          <p>Learn by building the simulation, not just watching one.</p>
        </div>
        <div class="mkt-footer-col">
          <h4>Product</h4>
          <a href="#/">Home</a>
          ${PAYMENTS_ENABLED ? '<a href="#/pricing">Pricing</a>' : ''}
          <a href="#/schools">For schools</a>
          <a href="#/login">Sign in</a>
        </div>
        <div class="mkt-footer-col">
          <h4>Company</h4>
          <a href="#/about">About</a>
          <a href="#/contact">Contact</a>
        </div>
        <div class="mkt-footer-col">
          <h4>Legal</h4>
          <a href="#/terms">Terms &amp; Conditions</a>
          <a href="#/privacy">Privacy Policy</a>
          <a href="#/refund">Refund &amp; Cancellation</a>
        </div>
      </div>
      <div class="mkt-footer-bottom">
        <span>© ${year} Simustage. All rights reserved.</span>
        <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>
      </div>
    </footer>
  `;
}

// Wraps page-specific body markup with the shared header/footer and writes
// it into the container. Returns nothing — call attachMktChrome after.
export function renderMarketingPage(container, active, signedIn, bodyHtml) {
  container.innerHTML = `
    <div class="mkt-page">
      ${mktHeader(active, signedIn)}
      ${bodyHtml}
      ${mktFooter()}
    </div>
  `;
  attachMktChrome(container);
}

export function attachMktChrome(container) {
  const toggle = container.querySelector('#mkt-nav-toggle');
  const nav = container.querySelector('#mkt-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => nav.classList.toggle('is-open'));
  }
}
